$(function () {
    $('.gottesdienste').each(function () {
        var $root = $(this),
            $dates = $('.date a', $root),
            $contents = $('.content-wrapper', $root),
            $scroller = $('.scroller', $root);

        $dates.click(function (e) {
            e.preventDefault();
            var $date = $(this),
                $content = $contents.eq($date.prevAll().length);
            $dates.removeClass('active');
            $contents.removeClass('active');
            $date.addClass('active');
            $content.addClass('active').trigger('mouseover');
        });

        $scroller.slimScroll({
            // width in pixels of the visible scroll area
            width: '100%',
            // height in pixels of the visible scroll area
            height: '300px',
            // width in pixels of the scrollbar and rail
            size: '7px',
            // scrollbar color, accepts any hex/color value
            color: '#000ec7',
            // scrollbar position - left/right
            position: 'right',
            // distance in pixels between the side edge and the scrollbar
            distance: '3px',
            // default scroll position on load - top / bottom / $('selector')
            start: 'top',
            // sets scrollbar opacity
            opacity: 1,
            // enables always-on mode for the scrollbar
            alwaysVisible: true,
            // check if we should hide the scrollbar when user is hovering over
            disableFadeOut: true,
            // sets visibility of the rail
            railVisible: true,
            // sets rail color
            railColor: '#fff',
            // sets rail opacity
            railOpacity: .2,
            // whether  we should use <a href="https://www.jqueryscript.net/tags.php?/jQuery UI/">jQuery UI</a> Draggable to enable bar dragging
            railDraggable: true,
            // default CSS class of the slimscroll rail
            railClass: 'slimScrollRail',
            // default CSS class of the slimscroll bar
            barClass: 'slimScrollBar',
            // default CSS class of the slimscroll wrapper
            wrapperClass: 'slimScrollDiv',
            // check if mousewheel should scroll the window if we reach top/bottom
            allowPageScroll: false,
            // scroll amount applied to each mouse wheel step
            wheelStep: 40,
            // scroll amount applied when user is using gestures
            touchScrollStep: 200,
            // sets border radius
            borderRadius: '0',
            // sets border radius of the rail
            railBorderRadius: '0'
        });

        $dates.first().addClass('active').trigger('mouseover');
    });
});
